import { VirtualCardSecureModel } from 'src/models/virtualCard.models'
import { type VirtualCardFormScreen } from 'src/queries/creditCards/domain/useVirtualCardFormCreditCards'

export function getFormScreenForVirtualCard(
  virtualCard: VirtualCardSecureModel | undefined,
): VirtualCardFormScreen {
  if (virtualCard === undefined) {
    return 'Standard'
  }
  if (virtualCard.isBillPay) {
    return 'BillPay'
  }
  if (virtualCard.isIssuerCycle) {
    return 'IssuerCycle'
  }
  if (virtualCard.features.balanceLocked) {
    return 'DecliningBalance'
  }
  if (virtualCard.direct) {
    return virtualCard.recurs ? 'RecurringGuest' : 'GuestAccess'
  }
  const isTogglingRecurrence =
    (virtualCard.recurs && virtualCard.pending?.recurs === undefined) ||
    (!virtualCard.recurs && virtualCard.pending?.recurs)
  if (isTogglingRecurrence) {
    return 'Recurring'
  }
  return 'Standard'
}
